import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import browserHistory from '../../history';
import Api from '../../services/ApiService';
import Form from '../form/Form';
import LoadingPage from '../LoadingPage';

const ItemEditContainer = ({
  action = 'edit',
  handleCancel = () => browserHistory.push('/'),
  isProcess = false,
  itemName = null,
  query = {},
}) => {
  const [ready, setReady] = useState(false);
  const [layout, setLayout] = useState({});
  const [page, setPage] = useState({});
  const [options, setOptions] = useState([]);

  const getFormData = () => {
    setReady(false);

    // Get the item data and config
    Api.get(`/item/${itemName}`).then(({ data }) => {
      const newPage = _.get(data, 'page') || {};
      newPage.page = _.get(data, 'yaml.page') || {};

      const jsonOptions = newPage.options ? Object.keys(newPage.options).map(o => o.toLowerCase()) : [];
      const yamlOptions = newPage.page.Options ? newPage.page.Options.map(o => o.toLowerCase()) : [];

      setOptions([...jsonOptions, ...yamlOptions]);
      setLayout(_.get(data, 'page_layout') || []);
      setPage(newPage);
      setReady(true);
    });
  };

  useEffect(() => {
    getFormData();
  }, []);

  const submit = payload => {
    if (isProcess) {
      return Api.post(`/item/${itemName}`, payload);
    }

    return Api.put(`/item/${itemName}`, payload);
  };

  const isOption = (name = '') => {
    if (!options) {
      return false;
    }

    return options.includes(name.toLowerCase());
  };

  const submitCallback = () => {
    if (isOption('ReloadOnSubmit')) {
      getFormData();
    }
  };

  if (!ready) {
    return <LoadingPage />;
  }

  const submitAll = isProcess || isOption('SubmitAll');
  const feedback = isProcess ? 'modal' : 'toaster';

  return (
    <Form
      action={isProcess ? 'process' : action}
      confirmSubmit={isOption('ConfirmSubmit')}
      feedback={feedback}
      initialValues={query}
      itemName={itemName}
      layout={layout}
      legacyFormat
      onCancel={handleCancel}
      page={page}
      readOnly={isOption('ReadOnly')}
      resetOnSubmit={isOption('ResetOnSubmit')}
      submit={submit}
      submitAll={submitAll}
      submitCallback={submitCallback}
    />
  );
};

ItemEditContainer.propTypes = {
  action: PropTypes.string,
  itemName: PropTypes.string,
  query: PropTypes.object,
  isProcess: PropTypes.bool,
  handleCancel: PropTypes.func,
};

export default ItemEditContainer;
